/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Action_RetryInputs */

const en_action_retry = /** @type {(inputs: Action_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try again`)
};

/** @type {(inputs: Action_RetryInputs) => LocalizedString} */
const ar_action_retry = en_action_retry;

/** @type {(inputs: Action_RetryInputs) => LocalizedString} */
const he_action_retry = en_action_retry;

/** @type {(inputs: Action_RetryInputs) => LocalizedString} */
const ur_action_retry = en_action_retry;

/** @type {(inputs: Action_RetryInputs) => LocalizedString} */
const es_action_retry = en_action_retry;

/** @type {(inputs: Action_RetryInputs) => LocalizedString} */
const fr_action_retry = en_action_retry;

/** @type {(inputs: Action_RetryInputs) => LocalizedString} */
const de_action_retry = en_action_retry;

/** @type {(inputs: Action_RetryInputs) => LocalizedString} */
const pt_action_retry = en_action_retry;

/** @type {(inputs: Action_RetryInputs) => LocalizedString} */
const hi_action_retry = en_action_retry;

/** @type {(inputs: Action_RetryInputs) => LocalizedString} */
const bn_action_retry = en_action_retry;

/**
* | output |
* | --- |
* | "Try again" |
*
* @param {Action_RetryInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const action_retry = /** @type {((inputs?: Action_RetryInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_RetryInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_action_retry(inputs)
	if (locale === "he") return he_action_retry(inputs)
	if (locale === "ur") return ur_action_retry(inputs)
	if (locale === "es") return es_action_retry(inputs)
	if (locale === "fr") return fr_action_retry(inputs)
	if (locale === "de") return de_action_retry(inputs)
	if (locale === "pt") return pt_action_retry(inputs)
	if (locale === "hi") return hi_action_retry(inputs)
	if (locale === "bn") return bn_action_retry(inputs)
	return /** @type {LocalizedString} */ ("Try again")
});